<template>
  <div class="mk-header-container">
    <a class="mk-header-logo" href="#" title="用友">
      <img
        :src="childItem.propsValue.data.customField1"
        width="100%"
        height="100%"
      />
    </a>
    <div class="mk-header-tel">
      <img
        src="https://www.yonyou.com/yingxiao/zd/u9c/zjtx/images/telephone1.svg"
        width="100%"
        height="100%"
      />
      <a >{{
        childItem.propsValue.data.customField2
      }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "MkHeaderPhone",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "图片",
          type: "image",
          width: 84,
          height: 62,
        },
        {
          code: "customField2",
          label: "电话",
          type: "text",
        },
      ],
      data: {
        customField1: "https://www.yonyou.com/static_new/img/icon/logo.png",
        customField2: "4006-600-577",
      },
    };
  },
};
</script>

<style scoped lang="scss">
.mk-header-container {
  height: 60px;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  .mk-header-logo {
    display: block;
    width: 50px;
    height: 35px;
    margin-left: 10px;
  }
  .mk-header-tel {
    width: calc(100% - 50px);
    height: 35px;
    line-height: 35px;
    text-align: right;
    padding-right: 20px;
    position: relative;
    img {
      position: absolute;
      top: 10px;
      width: 16px;
      height: 16px;
    }
    a {
      padding-left: 20px;
      font-size: 20px;
      font-weight: 500;
      color: #e60012;
    }
  }
}
</style>
